$(document).ready(function(){

});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/mxm_forum/index.js
 **/